/* eslint-disable react/jsx-no-target-blank */
// import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import PermissionsGate from '../../../../app/api/PermissionsGate';
import PrivateRoutesConfig from './../../../../app/routing/PrivateRoutesConfig'
import { GetPermissionForTitle, GetPermissionForRoute } from './../../../../app/Hooks/CustomHooks';

export function AsideMenuMain() {
    // const intl = useIntl()
    let sortedMenu = JSON.parse(JSON.stringify(PrivateRoutesConfig));
    sortedMenu.sort((a, b) => (a.menuOrder > b.menuOrder) ? 1 : ((b.menuOrder > a.menuOrder) ? -1 : 0))

    return (
        <>
            {
                sortedMenu.map((entry) => {
                    const { menutitle, routes } = entry;
                    return (
                        GetPermissionForTitle(entry) &&
                        <div key={JSON.stringify(entry)}>
                            {
                                menutitle &&
                                (
                                    <div className='menu-item'>
                                        <div className='menu-content pt-8 pb-2'>
                                            <span className='menu-section fw-bolder text-dark fs-7'>{menutitle}</span>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                routes && routes.map(
                                    (route) =>
                                    ((route.subRoutes && GetPermissionForRoute(route)) ?
                                        <AsideMenuItemWithSub
                                            to={route.to}
                                            key={JSON.stringify(route.subRoutes)}
                                            title={route.menuSubTitle}
                                            fontIcon='bi-archive'
                                            icon={route.icon}>
                                            {
                                                route.subRoutes.map((subRoute) =>
                                                    subRoute.menuTitle &&
                                                    <PermissionsGate key={subRoute.path + subRoute.menuTitle + JSON.stringify(subRoute.scopes)} RenderError={() => <></>} scopes={subRoute.scopes} >
                                                        <AsideMenuItem
                                                            // key={subRoute.path + subRoute.menuTitle}
                                                            to={subRoute.path}
                                                            title={subRoute.menuTitle}
                                                            hasBullet={true}
                                                        />
                                                    </PermissionsGate>
                                                )
                                            }
                                        </AsideMenuItemWithSub>
                                        :
                                        (route.menuTitle) &&
                                        <PermissionsGate key={route.path + route.menuTitle + JSON.stringify(route.scopes)} RenderError={() => <></>} scopes={route.scopes} >
                                            <AsideMenuItem
                                                // key={route.path + route.menuTitle}
                                                to={route.path}
                                                title={route.menuTitle}
                                                icon={route.icon}
                                                hasBullet={!Boolean(route.icon)}
                                            />
                                        </PermissionsGate>
                                    )
                                )
                            }

                        </div>

                    )
                }
                )
            }
        </>
    )

}
